import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import BASE_URL from "../config";

const UpdatePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const email = searchParams.get("email"); // Not required for API, but available

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (!token) {
      toast.error("Invalid or missing token");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${BASE_URL}api/user/update-password`, { token, password });
      toast.success("Password updated successfully. Please login.");
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="container d-flex justify-content-center align-items-center flex-grow-1">
        <div className="login-box p-4 shadow rounded bg-white" style={{ width: "100%", maxWidth: "400px" }}>
          <div className="text-center mb-4">
            <img
              src="https://res.cloudinary.com/softisans-com/image/upload/v1592236220/Logo/Softisans-Logo.png"
              alt="Softisans Logo"
              style={{ maxWidth: "180px", width: "60%", height: "auto" }}
            />
          </div>
          <h2 className="text-center">Update Password</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <input
                type="password"
                placeholder="New Password"
                className="form-control"
                value={password}
                onChange={e => setPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="form-group mb-3">
              <input
                type="password"
                placeholder="Confirm New Password"
                className="form-control"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? "Updating..." : "Update Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer /> {/* Add this line for toast notifications */}
    </div>
  );
};

export default UpdatePassword;
